import Page from 'components/layout/Page';
import DailyContact from './sections/contact/DailyContact';
import DailyFeatures from './sections/features/DailyFeatures';
import DailyHero from './sections/hero/DailyHero';
import DailyPricing from './sections/pricing/DailyPricing';

const DailyCompaniesComponent: React.FC = () => {
  return (
    <Page hasScrollTop pageVariant="light">
      <DailyHero />
      <DailyFeatures />
      <DailyPricing />
      <DailyContact />
    </Page>
  );
};

export default DailyCompaniesComponent;
